import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import 'react';

const SmallInformation = ({ testId, className, solid })=>{
    return /*#__PURE__*/ jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        "data-testid": testId,
        className: className,
        children: solid ? /*#__PURE__*/ jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14ZM7.00005 5.86249C7.38665 5.86249 7.70005 6.17589 7.70005 6.56249V10.0625C7.70005 10.4491 7.38665 10.7625 7.00005 10.7625C6.61345 10.7625 6.30005 10.4491 6.30005 10.0625V6.56249C6.30005 6.17589 6.61345 5.86249 7.00005 5.86249ZM6.99779 4.8125C6.51041 4.80988 6.12104 4.4135 6.12454 3.92612C6.12891 3.46062 6.52966 3.0625 6.99604 3.0625C7.47466 3.0625 7.88066 3.47025 7.87454 3.94713C7.86929 4.42225 7.47029 4.81512 6.99779 4.8125Z",
            fill: "currentColor"
        }) : /*#__PURE__*/ jsxs(Fragment, {
            children: [
                /*#__PURE__*/ jsxs("g", {
                    clipPath: "url(#clip0_3609_755)",
                    children: [
                        /*#__PURE__*/ jsx("circle", {
                            cx: "7",
                            cy: "7",
                            r: "6.3",
                            stroke: "currentColor",
                            strokeWidth: "1.4",
                            strokeLinejoin: "round"
                        }),
                        /*#__PURE__*/ jsx("path", {
                            d: "M7 10.0625V6.5625",
                            stroke: "currentColor",
                            strokeWidth: "1.4",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        }),
                        /*#__PURE__*/ jsx("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M6.99779 4.8125C6.51041 4.80988 6.12104 4.4135 6.12454 3.92612C6.12891 3.46062 6.52966 3.0625 6.99604 3.0625C7.47466 3.0625 7.88066 3.47025 7.87454 3.94713C7.86929 4.42225 7.47029 4.81512 6.99779 4.8125Z",
                            fill: "currentColor"
                        })
                    ]
                }),
                /*#__PURE__*/ jsx("defs", {
                    children: /*#__PURE__*/ jsx("clipPath", {
                        id: "clip0_3609_755",
                        children: /*#__PURE__*/ jsx("rect", {
                            width: "14",
                            height: "14",
                            fill: "white"
                        })
                    })
                })
            ]
        })
    });
};

export { SmallInformation as default };
